// extracted by mini-css-extract-plugin
export default {"block":"style_block__7kQBK"};